import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { CombinedFunnelComponentSteppedInputProps } from './CombinedFunnelMobile.types'
import { CombinedFunnelMobileAuth } from './Auth/Auth'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useCombinedFunnelMobileAuthState } from './Auth/Auth.hooks'
import { useOnce } from '@dtx-company/true-common/src/hooks/useOnce'
import { useState } from 'react'

export const CombinedFunnelMobileGenerateCode = (
  props: CombinedFunnelComponentSteppedInputProps
): JSX.Element => {
  const { variant } = props
  const { isAuthChecked, isAuthenticated } = useAuthState()

  const [isUserLoggedIn] = useState(isAuthChecked && isAuthenticated)
  const { handleGenerateCode } = useCombinedFunnelMobileAuthState(variant, !isUserLoggedIn)

  useOnce(() => {
    if (!isUserLoggedIn) return false
    handleGenerateCode()
  })

  if (isUserLoggedIn) {
    return (
      <Box flexDirection={'column'} m="16px 24px 6px" alignItems={'center'}>
        <Text
          fontSize={'18px'}
          fontWeight={600}
          lineHeight="22px"
          textAlign={'center'}
          maxWidth="297px"
        >
          Creating code...
        </Text>
      </Box>
    )
  }

  return <CombinedFunnelMobileAuth {...props} />
}
